
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syllabus/[key]",
      function () {
        return require("private-next-pages/syllabus/[key]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syllabus/[key]"])
      });
    }
  